import { createSlice } from "@reduxjs/toolkit";

// Define the initial state structure as an empty array
const initialState = [];

const Phases = createSlice({
    name: "phase",
    initialState,
    reducers: {
        // setTask: Add or update tasks in the array
        setPhases: (state, action) => {
            const phases = action.payload; // Assuming payload is an array of Phases objects
            return state = phases
        },

        // removePhases: Remove Phases by ID
        removePhases: (state, action) => {
            const PhasesIds = action.payload; // Assuming payload is an array of Phases IDs

            // Filter out Phases whose IDs are in the PhasesIds array
            return state.filter(Phases => !PhasesIds.includes(Phases.id));
        },

        // clearPhases: Clear all Phases
        clearPhases: () => {
            return []; // Return an empty array to clear all tasks
        },
    },
});

// Exporting the actions and reducer
export const { setPhases, removePhases, clearPhases } = Phases.actions;

export default Phases.reducer;
